const backendUrl = 'https://vaishliserver-production.up.railway.app/';

export default backendUrl;
